import React, { useState, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login";
import Search from "../pages/Search";
import Upload from "../pages/Upload";
import Top10 from "../pages/Top10";
import Admin from "../pages/Admin";
import Hedonic from "../components/studyDetails/Hedonic";
import Perception from "../components/studyDetails/Perception";
import NotFound from "../pages/NotFound";
import StudyDetails from "../pages/StudyDetails";
import LayoutDashboard from "../layouts/LayoutDashboard";
import AuthRouting from "./AppRouting";
import { ContextPermissionsProvider } from "../context/contextPermissions";
import jwtDecode from "../utils/jwtDecode";

import { usePermissionsContext } from "../context/contextPermissions";
import Spinner from "../components/common/spinner/Spinner";

import { useAuth0 } from "@auth0/auth0-react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/Sidebar";

export default function Routes() {
  const { isLoading, isAuthenticated, getAccessTokenSilently, logout } =
    useAuth0();

  const { permissions, setPermissions } = usePermissionsContext();

  const [showMenu, setShowMenu] = useState(true); // for hide/show buger
  const [mobileView, setMobileView] = useState(false); // for mobile screen

  const toggleMenu = () => setShowMenu(!showMenu);
  const isLoginPage = window.location.pathname === "/login";

  const updateViewState = () => {
    if (!mobileView && document.documentElement.clientWidth < 1024) {
      setShowMenu(false);
      setMobileView(true);
    } else if (document.documentElement.clientWidth > 1024) {
      setShowMenu(true);
      setMobileView(false);
    }
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <>
        {/* <ContextPermissionsProvider permissions={permissions}> */}
        <BrowserRouter>
          <Switch>
            <Route exact path="/">
              <LayoutDashboard>
                <ProtectedRoute component={Search} />
              </LayoutDashboard>
            </Route>

            <Route exact path="/search">
              <LayoutDashboard>
                <ProtectedRoute component={Search} />
              </LayoutDashboard>
            </Route>
            <Route exact path="/top10">
              <LayoutDashboard>
                <ProtectedRoute component={Top10} />
              </LayoutDashboard>
            </Route>

            <Route exact path="/upload">
              <LayoutDashboard>
                <ProtectedRoute
                  component={Upload}
                  role={permissions.upload_panel}
                />
              </LayoutDashboard>
            </Route>

            <Route exact path="/admin">
              <LayoutDashboard>
                <ProtectedRoute
                  component={Admin}
                  role={permissions.admin_panel}
                />
              </LayoutDashboard>
            </Route>

            <Route path="/view/:ownership/:client/:study_number/:country/:gender/:candidate">
              <LayoutDashboard>
                <ProtectedRoute component={StudyDetails} />
              </LayoutDashboard>
            </Route>

            <Route path="/login" exact component={Login} />
            <Route path="/not-found" component={NotFound} />
            <Redirect to="/not-found" />
          </Switch>
        </BrowserRouter>
        {/* </ContextPermissionsProvider> */}
      </>
    </>
  );
}
